'use client';

import { Badge } from '@mage-ui/components';
import { cx } from '@mage-ui/styled-system/css';
import {
	badge,
	courseCard,
	languageCourseDisplay,
	title,
} from '@mage-ui/styled-system/recipes';
import { InfoList } from '../../../layouts/lists/info-list/InfoList';
import { CourseCardFooter } from './CourseCardFooter';

export const CourseCard = ({ data, className, ...props }) => {
	return (
		<div className={className?.root ?? courseCard().root} {...props}>
			<div className={courseCard().topContent}>
				{data?.fields?.title ||
					(data?.title && (
						<Badge
							classNames={{ root: badge({ status: 'neutral', size: 's' }) }}
						>
							{data?.fields?.title || data?.title}
						</Badge>
					))}
			</div>
			<div className={courseCard().contentWrapper}>
				{data?.name && data?.iso && (
					<div
						className={cx(
							languageCourseDisplay().root,
							courseCard().metaWrapper,
						)}
					>
						<abbr
							title={data?.name}
							className={cx(
								title({ size: '2', weight: 'bold' }),
								languageCourseDisplay().title,
								courseCard().title,
							)}
						>
							{data?.fields?.iso || data?.iso}
						</abbr>
						<Badge aria-hidden='true' className={languageCourseDisplay().label}>
							{data?.fields?.name || data?.name}
						</Badge>
					</div>
				)}
				<InfoList className={courseCard().infoWrapper} data={data?.infoData} />
			</div>
			<CourseCardFooter data={data} />
		</div>
	);
};
